import CampusSelectionList from "@/app/_components/forms/CampusSelectionList";
import {
	ContactFormSelectedCampusHandlers,
	ContactFormSelectedCampuses,
} from "./contactFormUtils";
import Campus from "@/app/types/Campus";
import {TextFieldClasses} from "@/app/_components/forms/TextField";

export type ContactFormCampusSelectorsBaseProps = {
	campusList: Campus[];
	selectorClasses?: TextFieldClasses;
};

type ContactFormCampusSelectorsProps = Partial<ContactFormSelectedCampuses> &
	Partial<ContactFormSelectedCampusHandlers> &
	ContactFormCampusSelectorsBaseProps;

const getCampusText = (campus: Campus) => {
	const campusText = `${campus.locationName}, ${campus.stateAbbreviation}`;
	if (campus.comingSoon) {
		return `${campusText} (Coming Soon!)`;
	}
	return campusText;
};

const ContactFormCampusSelectors: React.FC<ContactFormCampusSelectorsProps> = ({
	selectorClasses,
	campusList,
	primaryCampus,
	// secondaryCampus,
	setPrimaryCampus,
	// setSecondaryCampus,
}) => {
	const disabledCampusKeys = campusList
		.filter((campus) => campus.comingSoon)
		.map((campus) => campus.campusId);

	return (
		<>
			<CampusSelectionList
				fieldName="campus_id"
				label="Campus Location of Interest"
				isRequired
				classes={selectorClasses}
				campusList={campusList}
				selectedKey={primaryCampus}
				onSelectionChange={setPrimaryCampus}
				getCampusListItemText={getCampusText}
				disabledKeys={disabledCampusKeys}
			/>
			{/* TODO: secondary campus selection removed for PROJ-23222.  leaving it commented
			out because we'll likely reintroduce the additional campus once we figure
			out how we want it to work. */}
			{/* <CampusSelectionList
				classes={selectorClasses}
				fieldName="additional_campus_id"
				label="Additional Campus Location of Interest"
				campusList={campusList}
				selectedKey={secondaryCampus}
				disabledKeys={primaryCampus ? [primaryCampus] : undefined}
				onSelectionChange={setSecondaryCampus}
				isDisabled={
					(primaryCampus !== undefined && !primaryCampus) || !campusList.length
				}
			/> */}
		</>
	);
};

export default ContactFormCampusSelectors;
